import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpLoaderService {
  //#region Service properties

  #counter = 0;
  displayLoader$ = new BehaviorSubject<boolean>(false);

  //#endregion

  //#region Public methods

  showLoader(): void {
    if (++this.#counter) {
      this.displayLoader$.next(true);
    }
  }

  hideLoader(): void {
    if (this.#counter > 0) {
      this.#counter--;
    }

    if (this.#counter === 0) {
      this.displayLoader$.next(false);
    }
  }

  //#endregion
}
